export const ADD_NODE="ADD_NODE";
export const REMOVE_NODE="REMOVE_NODE";
export const MODIFY_NODE="MODIFY_NODE";
export const UPDATED_NODE="UPDATED_NODE";